/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentTypeResponseDto } from './documentTypeResponseDto';
import { DocumentRelationshipResponseDto } from './documentRelationshipResponseDto';
import { DocumentContentResponseDto } from './documentContentResponseDto';


export interface DocumentReferenceResponseDto { 
    /**
     * Document reference identifier
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Document type identifier
     */
    documentTypeId: string;
    /**
     * Document type details (when requested via expand parameter)
     */
    documentType?: DocumentTypeResponseDto;
    /**
     * Subject of the document
     */
    subject: string;
    /**
     * Subject type (patient, encounter, etc.)
     */
    subjectType: string;
    /**
     * Author of the document
     */
    author: string;
    /**
     * Status of the document
     */
    status: DocumentReferenceResponseDto.StatusEnum;
    /**
     * Content of the document
     */
    content?: DocumentContentResponseDto;
    /**
     * Security level of the document
     */
    security: DocumentReferenceResponseDto.SecurityEnum;
    /**
     * Custom metadata
     */
    metadata?: any;
    /**
     * Document relationships
     */
    relationships: Array<DocumentRelationshipResponseDto>;
    /**
     * Creator identifier
     */
    createdBy: string;
    /**
     * Last updater identifier
     */
    updatedBy?: string;
    /**
     * Creation timestamp
     */
    createdOn: string;
    /**
     * Last update timestamp
     */
    updatedOn: string;
}
export namespace DocumentReferenceResponseDto {
    export type StatusEnum = 'open' | 'closed' | 'on_hold';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        Closed: 'closed' as StatusEnum,
        OnHold: 'on_hold' as StatusEnum
    };
    export type SecurityEnum = 'public' | 'confidential' | 'restricted' | 'very_restricted';
    export const SecurityEnum = {
        Public: 'public' as SecurityEnum,
        Confidential: 'confidential' as SecurityEnum,
        Restricted: 'restricted' as SecurityEnum,
        VeryRestricted: 'very_restricted' as SecurityEnum
    };
}


